import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  bordered: false,
  style: {"width":"1200px"},
  class: "table fixed-column-1"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { class: "chart-container" }

import ChartCustome from "../chart/ChartCustome.vue";
import AlertPopup from "../popup/AlertPopup.vue";
import { useRouter } from "vue-router";
import { ref } from "vue";
import { normalizeFloat } from "@app/@turnkeyidutils";
import { screenSizes } from "@/helper/index";
import { NAvatar, NIcon, NPopover, NTag, NTooltip, NTable } from "naive-ui";
interface IProps {
  userInvestment: any;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'GridTableInvestment',
  props: {
    userInvestment: {}
  },
  setup(__props: any) {

const router = useRouter();
const isOpen = ref(false);

const props = __props;

function toLink(data) {
  if (data.status === `pending`) {
    isOpen.value = true;
    return;
  }
  if (data.status === `pending-disconnect`) {
    return;
  }
  router.push(`/pamm/investor-account/my-investment/${data.id ? data.id : data._id}`);
}
function countGrowth(data) {
  const balance = data.account && data.account.investor_detail && data.account.investor_detail.Balance ? data.account.investor_detail.Balance : 0;
  const totalProfit = data.account && data.account.investor_detail && data.account.investor_detail.TotalProfit ? data.account.investor_detail.TotalProfit : 0;
  if (balance && totalProfit) {
    return normalizeFloat((totalProfit / balance) * 100, { toFixed: 2 });
  }
  return 0;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("colgroup", null, [
        _createElementVNode("col", {
          style: _normalizeStyle(_unref(screenSizes).xs ? 'width: 110px' : 'width: 320px')
        }, null, 4),
        _cache[1] || (_cache[1] = _createElementVNode("col", { style: {"width":"200px"} }, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("col", { style: {"width":"150px"} }, null, -1)),
        _cache[3] || (_cache[3] = _createElementVNode("col", { style: {"width":"150px"} }, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("col", { style: {"width":"180px"} }, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("col", { style: {"width":"150px"} }, null, -1)),
        _cache[6] || (_cache[6] = _createElementVNode("col", { style: {"width":"150px"} }, null, -1))
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
        _createElementVNode("tr", { class: "header" }, [
          _createElementVNode("th", { class: "text-nowrap" }, "Managers"),
          _createElementVNode("th", { class: "text-nowrap" }, "Status"),
          _createElementVNode("th", { class: "text-nowrap" }, "Growth"),
          _createElementVNode("th", { class: "text-nowrap" }, "Total Deposit"),
          _createElementVNode("th", { class: "text-nowrap" }, "Total Profit"),
          _createElementVNode("th", { class: "text-nowrap" }, "Total Withdraw"),
          _createElementVNode("th", { class: "text-nowrap" }, "Equity"),
          _createElementVNode("th", { class: "text-nowrap" }, "Disconnect Equity"),
          _createElementVNode("th", { class: "text-nowrap" }, "Overview")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userInvestment, (data, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, [
              _createElementVNode("div", {
                class: "d-flex pointer",
                onClick: ($event: any) => (toLink(data))
              }, [
                _createVNode(_unref(NAvatar), {
                  round: "",
                  size: "large",
                  src: data?.manager?.persona?.profile_pic_url || '/assets/img/avatar.svg',
                  placeholder: "/assets/img/avatar.svg",
                  alt: data?.manager?.manager_detail?.Name || '-',
                  class: "mr-2"
                }, null, 8, ["src", "alt"]),
                _createElementVNode("div", null, [
                  _createElementVNode("h6", {
                    class: "font-weight-bold mb-0 text-ellipsis",
                    style: _normalizeStyle(_unref(screenSizes).xs ? 'width: 110px' : 'width: 320px')
                  }, _toDisplayString(data?.manager?.manager_detail?.Name || "-"), 5),
                  _createElementVNode("small", _hoisted_3, " ID : " + _toDisplayString(data?.manager?.manager_detail?.Id || "-"), 1)
                ])
              ], 8, _hoisted_2)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", null, [
                _createVNode(_unref(NTag), {
                  round: "",
                  size: "small",
                  bordered: false,
                  type: data.status === 'connected' ? 'success' : data.status === 'disconnected' ? 'error' : data.status === 'pending' ? 'warning' : 'default'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.status), 1)
                  ]),
                  _: 2
                }, 1032, ["type"]),
                (data.status === `pending-disconnect` || data.status === `pending`)
                  ? (_openBlock(), _createBlock(_unref(NPopover), {
                      key: 0,
                      trigger: "hover",
                      placement: "right"
                    }, {
                      trigger: _withCtx(() => [
                        _createVNode(_unref(NIcon), { class: "ml-2" }, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "fa-solid fa-circle-info" }, null, -1)
                          ])),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _cache[8] || (_cache[8] = _createElementVNode("span", null, "please wait for money manager approval", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("td", {
              class: _normalizeClass(countGrowth(data) >= 0 ? 'green' : 'text-danger')
            }, _toDisplayString(countGrowth(data)) + "%", 3),
            _createElementVNode("td", null, _toDisplayString(_unref(normalizeFloat)(data?.account?.investor_detail?.Balance || 0, {
              toFixed: 2,
            })) + " USD ", 1),
            _createElementVNode("td", {
              class: _normalizeClass(data?.account?.investor_detail?.TotalProfit >= 0 ? 'green' : 'text-danger')
            }, _toDisplayString(_unref(normalizeFloat)(data?.account?.investor_detail?.TotalProfit || 0, {
              toFixed: 2,
            })) + " USD ", 3),
            _createElementVNode("td", {
              class: _normalizeClass(data?.invest_summary?.total_disconnect + data?.invest_summary?.total_withdraw >= 0 ? 'text-success' : 'text-danger')
            }, _toDisplayString(_unref(normalizeFloat)(data?.invest_summary?.total_disconnect + data?.invest_summary?.total_withdraw || 0, {
              toFixed: 2,
            })) + " USD ", 3),
            _createElementVNode("td", null, _toDisplayString(_unref(normalizeFloat)(data?.account?.investor_detail?.Equity || 0, {
              toFixed: 2,
            })) + " USD ", 1),
            _createElementVNode("td", null, _toDisplayString(_unref(normalizeFloat)(data?.account?.investor_detail?.Equity || 0, {
              toFixed: 2,
            })) + " USD ", 1),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(ChartCustome, {
                  type: "lineChart",
                  data: data.performanceHistory,
                  isProfit: data?.account?.investor_detail?.TotalProfit >= 0
                }, null, 8, ["data", "isProfit"])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(AlertPopup, {
      "is-open": isOpen.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = $event))
    }, null, 8, ["is-open"])
  ], 64))
}
}

})